import React from "react";
import SuperUserHomePageUI from "../../../templates/SuperUserHomePageUI";
import LRTableActionsUI from "../../../widgets/layout/LRTableActionsUI";
import CardUI from "../../../widgets/layout/CardUI";
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI";
import EmptyListUI from "../../../widgets/output/EmptyListUI";
import IconButtonUI from "../../../widgets/action/IconButtonUI";
import SwitchUI from "../../../widgets/action/SwitchUI";
import Currency from "../../../components/common/Currency";
import Icici733BalanceUpdateModalSF from "./Icici733BalanceUpdateModalSF";
import AdjustmentTransactionsModalSF from "./AdjustmentTransactionsModalSF";


// Custom Toggle Component
const CustomToggle = ({ checked, onChange, disabled = false }) => (
    <label className="custom-toggle">
        <input 
            type="checkbox" 
            checked={checked} 
            onChange={onChange}
            disabled={disabled}
        />
        <span className="custom-toggle-slider"></span>
    </label>
);

const EscrowAccountBalancePageUI = ({
    context, errorList, esccAccountList, dsraDipAccList, onRefreshClick, response, onEmailClick, onDownloadClick,
    showDsraTracker, onShowDsraTrackerClick, showTable, onShowTableClick, onDSRATrackerEmailClick,
    onEdit733Click, update733Mode, onCancel733Click, onSuccess733Click,
    onFdInterestClick, onGainOnMutualFundClick, onBankChargesClick, onPennyDropCreditClick, onWithdrawalClick,
    onFdBalanceClick,
    adjustmentModalOpen, adjustmentModalTitle, adjustmentModalTransactionList, adjustmentModalTotalAmount, adjustmentModalViewPageUrl, onAdjustmentModalClose
}) =>
    <SuperUserHomePageUI context={context} className='pg_su_acc_l' topnav='virtualAccounts' dimension='w1600'
        headerText={'Escrow Accounts'} centered={!esccAccountList || !errorList} page='virtualAccounts'>

        {
            (!esccAccountList || !errorList) &&
            <SpinnerComponentUI />
        }
        {
            esccAccountList &&
            <>
                <LRTableActionsUI location='top'
                    left={
                        <span className='g_flex_left g_flex_h'>
                            {/* <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' /> */}
                            <IconButtonUI icon='icon-envelope-o' onClick={onEmailClick} label='Self Email' />
                            <IconButtonUI icon='icon-download' onClick={onDownloadClick} />
                            <IconButtonUI icon='icon-envelope-o' onClick={onDSRATrackerEmailClick} label='DSRA Tracker Email' />
                            <span className='g_m_left_100 g_large'><b>Escrow Accounts Balance</b></span>
                        </span>
                    }
                    right={
                        <span></span>
                    }
                />
                <div className='g_m_top_20 g_m_bottom_60'>
                        <span className='g_small'>
                        <b>
                            Last updated on {response && response.latest733BalanceTimeStamp ? new Date(response.latest733BalanceTimeStamp).toLocaleString() : new Date().toLocaleString()}
                        </b>
                    </span>
                </div>
            </>
        }
        {
            esccAccountList && response && esccAccountList !== 0 &&
            <EscrowAccountUI
                esccAccountList={esccAccountList}
                response={response}
                dsraDipAccList={dsraDipAccList}
                showDsraTracker={showDsraTracker}
                onShowDsraTrackerClick={onShowDsraTrackerClick}
                showTable={showTable}
                onShowTableClick={onShowTableClick}
            />
        }
        {
            esccAccountList && response &&
            <div className='clime-summary-row'>
                <EscrowAccountSummary response={response} onEdit733Click={onEdit733Click} onFdBalanceClick={onFdBalanceClick} />
                <AdjustmentsSummary 
                    response={response} 
                    onFdInterestClick={onFdInterestClick}
                    onGainOnMutualFundClick={onGainOnMutualFundClick}
                    onBankChargesClick={onBankChargesClick}
                    onPennyDropCreditClick={onPennyDropCreditClick}
                    onWithdrawalClick={onWithdrawalClick}
                />
                <DifferenceSummary response={response} />
            </div>
        }
        {
            esccAccountList && esccAccountList.length === 0 &&
            <div className='g_m_top_50'>
                <EmptyListUI
                    context={context}
                    createEnabled={false}
                    createDisabledMessageLabel='No data yet'
                />
            </div>
        }
        
        <Icici733BalanceUpdateModalSF
            context={context}
            updateMode={update733Mode}
            currentBalance={response && response.latest733Balance ? response.latest733Balance : ''}
            onCancelClick={onCancel733Click}
            onSuccess={onSuccess733Click}
        />
        
        <AdjustmentTransactionsModalSF
            context={context}
            isOpen={adjustmentModalOpen}
            onRequestClose={onAdjustmentModalClose}
            title={adjustmentModalTitle}
            transactionList={adjustmentModalTransactionList}
            totalAmount={adjustmentModalTotalAmount}
            viewPageUrl={adjustmentModalViewPageUrl}
        />
    </SuperUserHomePageUI>

const EscrowAccountSummary = ({ response, onEdit733Click, onFdBalanceClick }) => {
    return (
            <div className='clime-summary'>
        <CardUI className='g_m_bottom_100' title={
            <span>
                B. Balance in Clime accounts (a+b+c) :- <span className='g_info'>₹ {response.sumBalanceInClimeAccounts}</span>
            </span>
        }>
            <div className='summary-rows'>
                <div className='summary-row'>
                    <span className='summary-label'>(a) Current Balance in 733</span>
                            <span className='summary-value'>₹ {response && response.latest733Balance ? response.latest733Balance : 0}
                                <span className='g_m_left_10' style={{ display: 'inline-block', verticalAlign: 'middle', transform: 'scale(0.8)' }}>
                                    <IconButtonUI icon='icon-pencil' onClick={onEdit733Click} title='Edit 733 Balance' />
                                </span>
                            </span>
                </div>
                <div className='summary-row'>
                    <span className='summary-label'>(b) FD balance</span>
                    <span className='summary-value'>
                        <a 
                            href='#' 
                            onClick={(e) => { e.preventDefault(); onFdBalanceClick && onFdBalanceClick(); }}
                            style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                        >
                            ₹ {response.fdBalance}
                        </a>
                    </span>
                </div>
                <div className='summary-row'>
                    <span className='summary-label'>(c) CSFB FD</span>
                    <span className='summary-value-container'>
                        <span className='summary-value'>₹ {response.csfbFd}</span>
                        <a href='/su/properties' className='edit-icon' title='Edit CSFB FD'>
                            <i className='icon-pencil'></i>
                        </a>
                    </span>
                </div>
            </div>
        </CardUI>
    </div>
    );
}
const EscrowAccountUI = ({ esccAccountList, response, dsraDipAccList, showDsraTracker, onShowDsraTrackerClick, showTable, onShowTableClick }) =>
    <div className='g_m_bottom_50'>
        <CardUI className='g_m_top_100' title={
            <span className='g_flex_h'>
                <span>{showDsraTracker ? 'DSRA Dip' : <>A. Balance in ESCC accounts :- <span className='g_success'>₹ {response.totalEsccBalF5}</span></>}</span>
                <span className='g_flex_h g_flex_right g_align_center'>
                    {!showDsraTracker && (
                        <div className='toggle-group'>
                            <div className='toggle-item'>
                                <span className='toggle-label'>
                                    <i className='icon-table'></i>
                                    Show Table
                                </span>
                                <CustomToggle checked={showTable} onChange={onShowTableClick} />
                            </div>
                        </div>
                    )}
                    <div className='toggle-group'>
                        <div className='toggle-item'>
                            <span className='toggle-label'>
                                <i className='icon-bar-chart'></i>
                                DSRA Dip
                            </span>
                            <CustomToggle checked={showDsraTracker} onChange={onShowDsraTrackerClick} />
                        </div>
                    </div>
                </span>
            </span>
        }
        >
            {
                !showDsraTracker && showTable &&
                <div className='escrow-table-container'>
                    <table className='escrow-table'>
                    <thead className="g_sticky">
                        <tr>
                            <th></th>
                            <th>Account</th>
                            <th>Total</th>
                            <th>Pending</th>
                            <th>DSRA Required</th>
                            <th>DSRA Dip</th>
                            <th>DSRA Current</th>
                            <th>Surplus</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            esccAccountList
                                // .filter(esccAccount => esccAccount.dsraDipF4 !== '0.00')
                                .map((esccAccount, i) =>
                                <>
                                    <tr key={i}>
                                        <td>{i + 1}.</td>
                                        <td>{esccAccount.accountName}</td>
                                        <td>{esccAccount.esccAccountBalanceF4}</td>
                                        <td>{esccAccount.esccPendingBalanceF4}</td>
                                        <td>{esccAccount.dsraRequestF4}</td>
                                        <td>{esccAccount.dsraDipF4}</td>
                                        <td>{esccAccount.dsraCurrentF4}</td>
                                        <td>{esccAccount.surplusF4}</td>
                                    </tr>
                                </>
                            )
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>Total</td>
                            <td>{response.totalEsccBalF5}</td>
                            <td>{response.totalPendingBalF5}</td>
                            <td>{response.totalDsraReqF5}</td>
                            <td>{response.totalDsraDipF5}</td>
                            <td>{response.totalDsraCurF5}</td>
                            <td>{response.totalSurplusF5}</td>
                        </tr>
                    </tfoot>
                    </table>
                </div>
            }
            {
                showDsraTracker &&
                <div className='escrow-table-container'>
                    <table className='escrow-table-dsra'>
                    <thead className="g_sticky">
                        <tr>
                            <th></th>
                            <th>Account</th>
                            <th>DSRA Required</th>
                            <th>DSRA Current</th>
                            <th>DSRA Dip</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            dsraDipAccList
                                .filter(esccAccount => esccAccount.dsraDipF4 !== '0.00')
                                .map((esccAccount, i) =>
                                <tr key={i}>
                                    <td>{i + 1}.</td>
                                    <td>{esccAccount.accountName}</td>
                                    <td>{esccAccount.dsraRequestF4}</td>
                                    <td>{esccAccount.dsraCurrentF4}</td>
                                    <td>{esccAccount.dsraDipF4}</td>
                                </tr>
                            )
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td>{response.totalDsraDipF5}</td>
                        </tr>
                    </tfoot>
                    </table>
                </div>
            }
        </CardUI>
    </div >

export default EscrowAccountBalancePageUI

const AdjustmentsSummary = ({ response, onFdInterestClick, onGainOnMutualFundClick, onBankChargesClick, onPennyDropCreditClick, onWithdrawalClick }) => {
    return (
        <div className='clime-summary'>
            <CardUI className='g_m_bottom_100' title={
                <span>
                    C. Transactions in 733 (a+b-c-d-e) :- <span className='g_info'>₹ {response.sumAdjustments}</span>
                </span>
            }>
                <div className='summary-rows'>
                    <div className='summary-row'>
                        <span className='summary-label'>(a) Interest on FD booked in 733</span>
                        <span className='summary-value'>
                            <a 
                                href='#' 
                                onClick={(e) => { e.preventDefault(); onFdInterestClick && onFdInterestClick(); }}
                                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                            >
                                ₹ {response.fdInterestEarned}
                            </a>
                        </span>
                    </div>
                    <div className='summary-row'>
                        <span className='summary-label'>(b) Gain on Mutual Funds</span>
                        <span className='summary-value'>
                            <a 
                                href='#' 
                                onClick={(e) => { e.preventDefault(); onGainOnMutualFundClick && onGainOnMutualFundClick(); }}
                                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                            >
                                ₹ {response.gainOnMutualFund}
                            </a>
                        </span>
                    </div>
                    <div className='summary-row'>
                        <span className='summary-label'>(c) Bank Charges</span>
                        <span className='summary-value-container'>
                            <span className='summary-value'>
                                <a 
                                    href='#' 
                                    onClick={(e) => { e.preventDefault(); onBankChargesClick && onBankChargesClick(); }}
                                    style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                                >
                                    ₹ {response.bankCharges}
                                </a>
                            </span>
                        </span>
                    </div>
                    <div className='summary-row'>
                        <span className='summary-label'>(d) Penny drop credit</span>
                        <span className='summary-value'>
                            <a 
                                href='#' 
                                onClick={(e) => { e.preventDefault(); onPennyDropCreditClick && onPennyDropCreditClick(); }}
                                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                            >
                                ₹ {response.pennyDropCredit}
                            </a>
                        </span>
                    </div>
                    <div className='summary-row'>
                        <span className='summary-label'>(e)  Withdrawal</span>
                        <span className='summary-value'>
                            <a 
                                href='#' 
                                onClick={(e) => { e.preventDefault(); onWithdrawalClick && onWithdrawalClick(); }}
                                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#1976d2' }}
                            >
                                ₹ {response.netInterestWithdrawal}
                            </a>
                        </span>
                    </div>
                </div>
            </CardUI>
        </div>
    );
}

const DifferenceSummary = ({ response, icici733 }) => {
    return (
        <div className='clime-summary'>
            <CardUI className='g_m_bottom_100' title={
                <span>
                    D. Difference (A-B+C) :- <span className='g_info'>₹ {response.difference}</span>
                </span>
            }>
            </CardUI>
        </div>
    );
}